<template>
  <div class="relative p-1 bg-backdrop-150 w-12 h-6 rounded-full shadow-inner transition-colors duration-300 ease-in-out"
       :class="{ 'bg-positive': modelValue }" @click="$emit('update:model-value', !modelValue)">
    <input :value="modelValue" type="checkbox" class="hidden" />
    <div class="absolute w-5 h-5 bg-white rounded-full left-0.5 top-0.5 transition-transform duration-300 ease-in-out"
         :class="{ 'transform translate-x-6': modelValue }"></div>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  emits: ['update:model-value'],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
